import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { service } from "@ember/service";
import GroupCard from "discourse/components/group-card";
import PluginOutlet from "discourse/components/plugin-outlet";
import bodyClass from "discourse/helpers/body-class";
import hideApplicationFooter from "discourse/helpers/hide-application-footer";
import withEventValue from "discourse/helpers/with-event-value";
import ComboBox from "discourse/select-kit/components/combo-box";
import { or } from "discourse/truth-helpers";
import DButton from "discourse/ui-kit/d-button";
import DConditionalLoadingSpinner from "discourse/ui-kit/d-conditional-loading-spinner";
import DLoadMore from "discourse/ui-kit/d-load-more";
import { i18n } from "discourse-i18n";

export default class GroupList extends Component {
  @service currentUser;
  @service router;

  @action
  new() {
    this.router.transitionTo("groups.new");
  }

  @action
  loadMore() {
    this.args.groups?.loadMore();
  }

  get types() {
    const types = [];
    const typeFilters = this.args.groups.extras.type_filters;

    if (typeFilters) {
      typeFilters.forEach((type) =>
        types.push({ id: type, name: i18n(`groups.index.${type}_groups`) })
      );
    }

    return types;
  }

  <template>
    {{#if (or @groups.loadingMore @groups.canLoadMore)}}
      {{hideApplicationFooter}}
    {{/if}}

    {{bodyClass "groups-page"}}

    <PluginOutlet
      @name="before-groups-index-container"
      @connectorTagName="div"
    />

    <section class="container groups-index">
      <div class="groups-header">
        {{#if this.currentUser.can_create_group}}
          <DButton
            @action={{this.new}}
            @icon="plus"
            @label="admin.groups.new.title"
            class="btn-default groups-header-new pull-right"
          />
        {{/if}}

        <div class="groups-header-filters">
          <input
            value={{@filter}}
            placeholder={{i18n "groups.index.all"}}
            class="groups-header-filters-name no-blur"
            {{on "input" (withEventValue @onFilterChanged)}}
            type="search"
            aria-label={{i18n "groups.index.search_results"}}
          />

          <ComboBox
            @value={{@type}}
            @content={{this.types}}
            @onChange={{@onTypeChanged}}
            @options={{hash clearable=true none="groups.index.filter"}}
            class="groups-header-filters-type"
          />
        </div>
      </div>

      {{#if @groups.content}}
        <DLoadMore @action={{this.loadMore}}>
          <div class="container">
            <div class="groups-boxes">
              {{#each @groups.content as |group|}}
                <GroupCard @group={{group}} />
              {{/each}}
              <PluginOutlet
                @name="groups-boxes-additional-cards"
                @connectorTagName="div"
              />
            </div>
          </div>
        </DLoadMore>
        <DConditionalLoadingSpinner @condition={{@groups.loadingMore}} />
      {{else}}
        <p role="status">{{i18n "groups.index.empty"}}</p>
      {{/if}}
    </section>
  </template>
}
